import { ServiceContainer } from '@tv2-player/service-container/src/serviceContainer';
import URLSearchParamsPonyfill from 'core-js-pure/actual/url-search-params';
import { AdVendor } from '../types';
import { devFlags } from '../util/devFlags';
import { getFirstCapabilityValue } from '../util/hasCapability';
import { MediaStream } from './types';

type TestStreams = typeof testStreams;
type TestStream = keyof TestStreams;
type PlaybackFormat = 'DASH_MULTI_PERIOD' | 'HLS';
type SatisfyTestStreams = Record<
  string,
  Record<
    PlaybackFormat,
    {
      url: string;
      adVendor: AdVendor;
    }
  >
>;

const testStreams = {
  'Looping LAR - Normal': {
    DASH_MULTI_PERIOD: {
      url: 'https://csm-e-tv2dklive-eb.bln1.yospace.com/csm/extlive/tv2dkdev01,dev_tv2_avsync_loop.mpd',
      adVendor: AdVendor.YOSPACE_CS,
    },
    HLS: {
      url: 'https://pubads.g.doubleclick.net/ssai/event/n4u3rGFXRwST7GZhvJEuYw/master.m3u8',
      adVendor: AdVendor.GOOGLE,
    },
  },

  'Looping LAR - Frequency Cap': {
    DASH_MULTI_PERIOD: {
      url: 'https://csm-e-tv2dklive-eb.bln1.yospace.com/csm/extlive/tv2dkdev01,dev_tv2_dash_loop_freq.mpd',
      adVendor: AdVendor.YOSPACE_CS,
    },
    HLS: {
      url: 'https://csm-e-tv2dklive-eb.bln1.yospace.com/csm/extlive/tv2dkdev01,dev_tv2_avdesync_hls_aac_freq.m3u8',
      adVendor: AdVendor.YOSPACE_CS,
    },
  },
} satisfies SatisfyTestStreams;

function updateCapabilityValue(stream: MediaStream, capabilityType: string, value: string) {
  return stream?.capabilities?.map(capability => {
    if (capability?.capabilityType === capabilityType) {
      return {
        ...capability,
        values: [value],
      };
    }
    return capability;
  });
}

function mapTestStreamToStreams(stream: MediaStream) {
  const testStream = ServiceContainer.config.get(devFlags.testStream) as TestStream;
  const playbackFormat = getFirstCapabilityValue(stream?.capabilities, 'FORMAT') as PlaybackFormat;
  const playback = testStreams[testStream][playbackFormat];

  if (!playback || !stream?.url) {
    return stream;
  }

  const streamParams = new URLSearchParamsPonyfill(new URL(stream.url).search);
  const streamUrl = new URL(playback.url);

  if (playback.adVendor === AdVendor.YOSPACE_CS) {
    const yospaceParams = new URLSearchParamsPonyfill(
      '?yo.ac=true&yo.ad=true&ss_req=1&yo.d.mc=true&yo.pbr=true&ss_req=0'
    );
    yospaceParams.forEach((value, key) => {
      streamParams.append(key, value);
    });
  }

  streamUrl.search = streamParams.toString();
  stream.url = streamUrl.toString();
  stream.capabilities =
    updateCapabilityValue(stream, 'LAR', playback.adVendor) || stream.capabilities;

  return stream;
}

export function switchStreamURL(streams: MediaStream[]) {
  const enabledTestStreams = ServiceContainer.config.get(devFlags.enableTestStreams);
  const testStream = ServiceContainer.config.get(devFlags.testStream) as TestStream;

  if (!enabledTestStreams || !streams || !testStreams[testStream]) {
    return streams;
  }

  return streams.map(mapTestStreamToStreams);
}
